export const LOADING_MESSAGES = [
  "loadingMessages.weather",
  "loadingMessages.topography",
  "loadingMessages.vegetation",
  "loadingMessages.finalizing",
];